class deliveryEstimates extends HTMLElement {
    constructor() {
        super();
        this.deliveryDays = Number(this.getAttribute('data-delivery-days'));
        this.cutoffTime = this.getAttribute('data-cutoff-time');
        this.holidays = this.getAttribute('data-holidays') || [];
        this.mess = this.getAttribute('data-mess');

        let self = this;
        let dateDelivery = this.makeDeliveryCalculator(self);
        dateDelivery = this.formatDate(dateDelivery)

        this.innerHTML = this.mess.replaceAll('{{date}}', dateDelivery)
    }

    formatDate(date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0'); // Lấy ngày và thêm số 0 nếu cần
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Lấy tháng (bắt đầu từ 0)
        const year = String(d.getFullYear()).slice(-2); // Lấy 2 chữ số cuối của năm

        return `${day}/${month}/${year}`;
    }


    makeDeliveryCalculator(self) {

        let  cutOffTime = self.cutoffTime, excludeDaysOfWeek = [0, 6],holidays = self.holidays.split(",");

        let nowInSpain = new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" });
        let now = new Date(nowInSpain);


        let [cutOffHours, cutOffMinutes] = cutOffTime.split(/:/)
        let cutOffDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutOffHours, cutOffMinutes, 0, 0);

        // if cut-off time passed, add one day
        const n = self.deliveryDays + (now > cutOffDate ? 1 : 0);

        const formatter = new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });

        const today = new Date(now)
        today.setHours(0, 0, 0, 0)

        let deliveryOn = new Date(today)

        let i = 0
        while (true) {
            // let yyyymmdd = formatter.format(deliveryOn)

            let dayMonth = `${deliveryOn.getDate()}/${deliveryOn.getMonth() + 1}/${deliveryOn.getFullYear()}`;

            let canDelivery = !excludeDaysOfWeek.includes(deliveryOn.getDay()) &&
                !holidays.some(pattern => dayMonth.endsWith(pattern))

            if (canDelivery) {
                if (i++ === n) {
                    break
                }
            }
            deliveryOn.setDate(deliveryOn.getDate() + 1)
        }

        return deliveryOn;
    }
}
customElements.define('delivery-date', deliveryEstimates)